import { render, staticRenderFns } from "./common.vue?vue&type=template&id=a59dc962&scoped=true&"
import script from "./common.vue?vue&type=script&lang=js&"
export * from "./common.vue?vue&type=script&lang=js&"
import style0 from "./common.vue?vue&type=style&index=0&id=a59dc962&lang=less&scoped=true&"
import style1 from "./common.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59dc962",
  null
  
)

export default component.exports